class TrScrollContent extends HTMLElement {
	selectors = {
		content: '[data-content]',
		bar: '[data-bar]'
	};

	constructor() {
		super();
	}

	connectedCallback() {
		this.init();
	}

	init() {
		this.contentElement = this.querySelector(this.selectors.content);
		this.barElement = this.querySelector(this.selectors.bar);

		if (!this.contentElement || !this.barElement) return;

		this.updateBarVisibility();
		this.updateBarSize();
		this.bindEvents();
	}

	calculateMaxScrollTop() {
		return this.contentElement.scrollHeight - this.contentElement.offsetHeight;
	}

	updateBarVisibility() {
		const maxScrollTop = this.calculateMaxScrollTop();

		this.barElement.style.opacity = maxScrollTop > 0 ? 1 : 0;
	}

	updateBarSize() {
		const visibleRatio =
			this.contentElement.offsetHeight / this.contentElement.scrollHeight;

		const thumbHeightPercent = Math.max(visibleRatio * 100, 10);
		this.barElement.style.setProperty(
			'--scrollBarSize',
			`${thumbHeightPercent}%`
		);
	}

	bindEvents() {
		this.contentElement.addEventListener('scroll', this.onScroll);
		window.addEventListener('resize', this.onResize);
	}

	onResize = () => {
		this.updateBarVisibility();
		this.updateBarSize();
		this.onScroll({ currentTarget: this.contentElement });
	};

	onScroll = event => {
		const content = event.currentTarget;
		const maxScrollTop = this.calculateMaxScrollTop();
		let progressScroll = 0;

		if (maxScrollTop > 0) {
			const thumbHeightPercent = parseFloat(
				getComputedStyle(this.barElement).getPropertyValue('--scrollBarSize')
			);

			const maxProgress = 100 - thumbHeightPercent;

			progressScroll = Math.round(
				Math.max(
					Math.min(
						(content.scrollTop / maxScrollTop) * maxProgress,
						maxProgress
					),
					0
				)
			);
		}

		this.barElement.style.setProperty('--scrollProgress', `${progressScroll}%`);
	};

	update() {
		this.updateBarVisibility();
		this.updateBarSize();
		this.onScroll({ currentTarget: this.contentElement });
	}
}

customElements.define('tr-scroll-content', TrScrollContent);
